import { Controller } from '@hotwired/stimulus'

/**
 * CTA Tracking Controller
 * Tracks CTA button clicks and form submissions using Ahoy for analytics
 *
 * Usage for buttons:
 *   <button data-controller="public--cta-tracking"
 *           data-action="click->public--cta-tracking#trackClick"
 *           data-button-type="consultation"
 *           data-button-location="hero">
 *
 * Usage for forms:
 *   <form data-controller="public--cta-tracking"
 *         data-action="submit->public--cta-tracking#trackFormSubmit"
 *         data-public--cta-tracking-cta-name-value="contact_form">
 */
export default class extends Controller {
  static values = {
    ctaName: { type: String, default: 'unknown' }
  }

  trackClick(event) {
    const button = event.currentTarget
    const buttonType = button.dataset.buttonType || this.ctaNameValue || 'unknown'
    const buttonLocation = button.dataset.buttonLocation || 'unknown'
    const buttonText = button.textContent?.trim()

    if (typeof ahoy !== 'undefined') {
      ahoy.track('cta_clicked', {
        button_type: buttonType,
        button_location: buttonLocation,
        button_text: buttonText,
        page: window.location.pathname
      })
    }
  }

  trackFormSubmit(event) {
    const form = event.currentTarget
    const formName = this.ctaNameValue || form.dataset.formName || 'unknown'

    // Don't track if submission was prevented (e.g., by validation) or form is invalid
    if (event.defaultPrevented || !form.checkValidity()) {
      return
    }

    if (typeof ahoy !== 'undefined') {
      ahoy.track('form_submitted', {
        form_name: formName,
        page: window.location.pathname
      })
    }
  }
}
